export const OmniboxTelemetryEventSource = 'omni';
